import React, { useRef, useEffect } from 'react';
import { Menu, Flex, Typography, Avatar } from 'antd';

const { Text } = Typography;

const getNameInitials = (name) => {
  return name
    ?.split(' ')
    ?.map((n) => n[0])
    ?.join('')
    ?.slice(0, 2)
    ?.toUpperCase();
};

export const ShortcutMenu = React.memo(
  ({ items, displayLabel = true, onClickHandler, selectedOption, width, height }) => {
    const menuRef = useRef(null);

    useEffect(() => {
      if (menuRef.current) {
        const menu = menuRef.current;
        const menuItems = menu.querySelectorAll('[data-key]');
        const selectedItem = Array.from(menuItems).find((item) => item.dataset.key === selectedOption);
        if (selectedItem) {
          const menuRect = menu.getBoundingClientRect();
          const itemRect = selectedItem.getBoundingClientRect();
          if (itemRect.bottom >= menuRect.bottom) menu.scrollTop += itemRect.bottom - menuRect.bottom + 20;
          else if (itemRect.top <= menuRect.top) menu.scrollTop -= menuRect.top - itemRect.top + 20;
        }
      }
    }, [selectedOption]);
    return (
      <Flex
        ref={menuRef}
        style={{ '--shortcut-menu-width': width, '--shortcut-menu-height': height }}
        className="cms-shortcut-menu-wrapper shortcut-menu-wrapper"
      >
        <Menu selectedKeys={[selectedOption]} className="shortcut-menu">
          {Object.entries(items).map(([key, items]) => {
            return (
              <>
                {displayLabel && <Menu.Item className="group__label">{key}</Menu.Item>}
                {items?.map(({ key, displayName, icon: IconComponent, avatar }) => {
                  const initials = getNameInitials(displayName);

                  return (
                    <Menu.Item
                      data-key={key}
                      onClick={() => onClickHandler({ key })}
                      className="shortcut-menu-item"
                      key={key}
                      style={{ width: '100%' }}
                    >
                      <Flex className="menu-item-inner">
                        <div className="icon-wrapper">{IconComponent && <IconComponent />}</div>
                        {avatar && (
                          <Avatar style={{ minWidth: 26, minHeight: 26, maxWidth: 26, maxHeight: 26 }}>
                            {initials}
                          </Avatar>
                        )}
                        <Text ellipsis className="text">
                          {displayName}
                        </Text>
                      </Flex>
                    </Menu.Item>
                  );
                })}
              </>
            );
          })}
        </Menu>
      </Flex>
    );
  }
);

export default ShortcutMenu;
